// Define collapsible-nav-menu component as a custom web component
class CollapsibleNavMenu extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initCollapsible();
    }

    initCollapsible() {
        // Get all collapsible triggers
        const triggers = document.querySelectorAll('[data-collapsible-trigger]');

        // Initialize all containers to be hidden
        document.querySelectorAll('[data-collapsible-container]').forEach((container) => {
            container.style.display = 'none';
            container.setAttribute('aria-hidden', 'true');
        });

        // Add click event to each trigger
        triggers.forEach((trigger) => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();

                // Find the container this trigger controls
                const containerId = trigger.getAttribute('aria-controls');
                const container = document.getElementById(containerId);

                if (!container) return;

                // Get current state
                const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

                // Toggle icons
                const plusIcon = trigger.querySelector('.icon-plus');
                const minusIcon = trigger.querySelector('.icon-minus');

                if (plusIcon) plusIcon.style.display = isExpanded ? 'inline-block' : 'none';
                if (minusIcon) minusIcon.style.display = isExpanded ? 'none' : 'inline-block';

                // Update ARIA attributes
                trigger.setAttribute('aria-expanded', !isExpanded);
                container.setAttribute('aria-hidden', isExpanded);

                // Simple toggle display
                if (isExpanded) {
                    container.style.display = 'none';
                } else {
                    container.style.display = 'block';
                }
            });
        });
    }
}

// Register the custom element
if (!customElements.get('collapsible-nav-menu')) {
    customElements.define('collapsible-nav-menu', CollapsibleNavMenu);
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector('collapsible-nav-menu')) {
        const navComponent = document.createElement('collapsible-nav-menu');
        document.body.appendChild(navComponent);
    }
});